import type { NavigationTab } from '@swf/poker';

import BronzePass from './assets/bronze_pass_card.png';
import GoldPass from './assets/gold_pass_card.png';
import SilverPass from './assets/silver_pass_card.png';
import {
  TXTCLI_BRONZE_POWER_PASS,
  TXTCLI_GOLD_POWER_PASS,
  TXTCLI_More,
  TXTCLI_N0_N1_N2_entries,
  TXTCLI_N0_N1_N2_entry,
  TXTCLI_N0_N1_N2_ticket,
  TXTCLI_N0_N1_N2_tickets,
  TXTCLI_N0_nights_at_N1___N2_XN3X_,
  TXTCLI_NEW_BRONZE_BUNDLE,
  TXTCLI_NEW_GOLD_BUNDLE,
  TXTCLI_NEW_SILVER_BUNDLE,
  TXTCLI_Overview,
  TXTCLI_Plus_remaining_value_of_the_N0_ELL,
  TXTCLI_SILVER_POWER_PASS,
  TXTCLI_The_Passes,
  TXTCLI_The_Path,
  TXTINT_Friday,
  TXTINT_Monday,
  TXTINT_Saturday,
  TXTINT_Sunday,
  TXTINT_Thursday,
  TXTINT_Tuesday,
  TXTINT_Wednesday
} from './constants.messages.json';
import type { EventType, NavigationTabTypes, PassAwardTranslations } from './types';
import { Award, Event, NAVIGATION_TABS_TYPE_URL_MAP, NavigationTabs, PassType } from './types';

export const NAVIGATION_DATA: Record<NavigationTabTypes, NavigationTab<NavigationTabTypes>> = {
  overview: {
    title: TXTCLI_Overview,
    shortTitle: TXTCLI_Overview,
    tabName: NavigationTabs.overview,
    alias: 'pokerPowerPath',
    routeValues: {
      tab: NAVIGATION_TABS_TYPE_URL_MAP.overview
    }
  },
  thePath: {
    title: TXTCLI_The_Path,
    shortTitle: TXTCLI_The_Path,
    tabName: NavigationTabs.thePath,
    alias: 'pokerPowerPath',
    routeValues: {
      tab: NAVIGATION_TABS_TYPE_URL_MAP.thePath
    }
  },
  thePasses: {
    title: TXTCLI_The_Passes,
    shortTitle: TXTCLI_The_Passes,
    tabName: NavigationTabs.thePasses,
    alias: 'pokerPowerPath',
    routeValues: {
      tab: NAVIGATION_TABS_TYPE_URL_MAP.thePasses
    }
  },
  more: {
    title: TXTCLI_More,
    shortTitle: TXTCLI_More,
    tabName: NavigationTabs.more,
    alias: 'pokerPowerPath',
    routeValues: {
      tab: NAVIGATION_TABS_TYPE_URL_MAP.more
    }
  }
};

export const NAVIGATION_TABS: NavigationTab<NavigationTabTypes>[] = [
  NAVIGATION_DATA.overview,
  NAVIGATION_DATA.thePath,
  NAVIGATION_DATA.thePasses,
  NAVIGATION_DATA.more
];

export const ENDPOINTS = {
  HTTP: {
    real: '/api/v1-preview/mtt/powerpath',
    mock: '/api/v1-preview/mtt/powerpathmock',
    redeem: '/api/v1-preview/mtl/pass/redeem'
  },
  WS: {
    real: '/api/v1-preview/stream/mtt/powerpath',
    mock: '/api/v1-preview/stream/mtt/powerpathmock'
  }
};

export const PASSES_TITLE_TRANSLATIONS = {
  [PassType.gold]: TXTCLI_GOLD_POWER_PASS,
  [PassType.silver]: TXTCLI_SILVER_POWER_PASS,
  [PassType.bronze]: TXTCLI_BRONZE_POWER_PASS
};
export const COMING_SOON_PASSES_TRANSLATIONS = {
  [PassType.gold]: TXTCLI_NEW_GOLD_BUNDLE,
  [PassType.silver]: TXTCLI_NEW_SILVER_BUNDLE,
  [PassType.bronze]: TXTCLI_NEW_BRONZE_BUNDLE
};

export const MINIMUM_PASS_COUNT = 3;

export const PASS_IMAGES = {
  [PassType.gold]: GoldPass,
  [PassType.silver]: SilverPass,
  [PassType.bronze]: BronzePass
};

export const PASS_AWARD_TRANSLATIONS: PassAwardTranslations = {
  [Award.Ticket]: {
    SINGULAR: TXTCLI_N0_N1_N2_ticket,
    PLURAL: TXTCLI_N0_N1_N2_tickets
  },
  [Award.Entry]: {
    SINGULAR: TXTCLI_N0_N1_N2_entry,
    PLURAL: TXTCLI_N0_N1_N2_entries
  },
  [Award.Hotel]: TXTCLI_N0_nights_at_N1___N2_XN3X_,
  [Award.Addon]: TXTCLI_Plus_remaining_value_of_the_N0_ELL
};

export const EVENT_TYPE_TRANSLATIONS: {
  [K in EventType]: string;
} = {
  [Event.Series]: 'Series Dates',
  [Event.Festival]: 'Festival Dates',
  [Event.Recurring]: 'Every'
};

export const DAY_OF_WEEK_TRANSLATIONS = [
  TXTINT_Monday,
  TXTINT_Tuesday,
  TXTINT_Wednesday,
  TXTINT_Thursday,
  TXTINT_Friday,
  TXTINT_Saturday,
  TXTINT_Sunday
];
